module.exports = __webpack_public_path__ + "img/472-fd54e2.png";